<template lang="pug">
div(class="absolute top-full")
    div(data-testid="treeMenu" class="flex flex-nowrap")
        ul(class="bg-gray-darkest rounded-bl min-w-[240px]")
            template(v-for="item, index in data.items")
                template(v-if="$storyblok.isVisible(item)")
                    //- Relative is required for triangle to work.
                    li(
                        data-testid="treeMenuRootItem"
                        @touchstart="showMenu(index)"
                        @mouseenter="showMenu(index)"
                        @mouseleave="clearTimer"
                        class="relative"
                        v-bind="bindStoryblokBridgeData(item)"
                    )
                        //- Panel 1
                        div(
                            class="pl-3 pr-10 py-4 font-bold text-light triangle triangle-thick cursor-default hover:bg-white hover:text-black"
                        ) {{item.text}}

        //- Panel 2
        template(v-for="item, index in data.items")
            template(v-if="item.items")
                template(v-if="$storyblok.isVisible(item)")
                    TreeItem(
                        v-show="activeMenuIndex===index"
                        :data="item"
                        :isActive="activeMenuIndex===index"
                    )
</template>

<script>
import { bindStoryblokBridgeData } from '../../../helpers'
import TreeItem from './treeItem.vue'
export default {
    name: 'TreeMenu',
    components: { TreeItem },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activeMenuIndex: null,
        }
    },
    watch: {
        isActive(newVal) {
            this.activeMenuIndex = newVal ? 0 : null
        },
    },
    methods: {
        bindStoryblokBridgeData,
        clearTimer() {
            // If they mouseleave before the showMenu timer is done, clear it so we don't show it
            clearTimeout(this.navHoverTimer)
        },
        showMenu(menuIndex) {
            clearTimeout(this.navHoverTimer)

            this.navHoverTimer = setTimeout(() => {
                this.activeMenuIndex = menuIndex
            }, 175)
        },
    },
}
</script>
